<template>
  <div class="notification">
    <p class="mb">Laba diena,</p>
    <div>Ačiū, kad naudojatės platforma</div>
    <img class="img mb" src="/img/img/logo.png" alt="DraudimoIvykiai.lt" />

    <div class="box">
      Informuojame Jus, kad paslauga adresu <a href="https://paslaugos.cab.lt" target="_blank">https://paslaugos.cab.lt</a> nebepalaikoma,
      <div>todėl kviečiame naudotis paslauga adresu</div>
      <div><a href="https://draudimoivykiai.lt" target="_blank">https://draudimoivykiai.lt</a></div>
      ir iš naujo išsaugoti platformos nuorodą darbastalyje.
    </div>
    <p><a href="https://draudimoivykiai.lt" target="_blank">Draudimoivykiai.lt</a> komanda</p>
  </div>
</template>

<script>
export default {
  name: "notification-comp",
  props: {},
  data: () => ({}),
};
</script>

<style scoped>
.notification {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.box {
  line-height: 1.5;
  max-width: 600px;
  padding-bottom: 12px;
}
.img {
  max-width: 200px;
}
.mb {
  margin-bottom: 28px;
}
</style>
